import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// INTERCEPTEUR DE REQUÊTE (L'ALLER)
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authenticationToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// INTERCEPTEUR DE RÉPONSE (LE RETOUR)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";

    const isPasswordResetRequest =
      url.includes("/users/reset-password/init") ||
      url.includes("/users/reset-password/finish");

    if (status === 401 && !isPasswordResetRequest) {
      console.warn("Session expirée ou non autorisée. Redirection...");

      localStorage.removeItem("authenticationToken");
      window.location.href = "/auth/login";
    }

    return Promise.reject(error);
  },
);

export default api;
